export enum CommonEvents {
  CLICK_ON_ENDPOINT_NAME = 'clickOnEndpointName',
  CLICK_ON_POLICY_NAME = 'clickOnPolicyName',
  CLICK_ON_RULE_SET_NAME = 'clickOnRuleSetName',
  CLICK_ON_INCIDENT_NUMBER = 'clickOnIncidentNumber',
  VALIDITY_CHANGE = 'validityChange',
}
